import axios from "axios";
import { MailCallbackCallResponse, MailCallbackRequestForUserPrompt, MailCallbackUserPrompt } from "@/dto/mail/callback/MailCallback";
import {MAIL_CALLBACK_ENDPOINT} from "@/constants/endpoints";

class MailCallbackService {
    
    callCallback(token: string) {
        return axios.post<MailCallbackCallResponse | MailCallbackRequestForUserPrompt>(`${MAIL_CALLBACK_ENDPOINT}/${token}`);
    }

    runCallbackAction(token: string, prompt: MailCallbackUserPrompt) {
        return axios.post<MailCallbackCallResponse>(`${MAIL_CALLBACK_ENDPOINT}/${token}/run`, prompt);
    }
}

export default new MailCallbackService();
